import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getVolunteer,
  editVolunteer,
} from "../../store/actions/volunteers_action";
import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom";
import Spinner from "../../components/layout/Spinner";
import AddForm from "../../components/common/AddForm";
import { upload } from "../../shared/upload";
import { initialValues, inputFields } from "../../shared/enums/volunteers_enum";

const EditVolunteer = ({
  editVolunteer,
  getVolunteer,
  match,
  volunteer: { loading, volunteer },
}) => {
  let history = useHistory();
  useEffect(() => {
    getVolunteer(match.params.id);
  }, [match]);
  const [featuredImage, setFeaturedImage] = useState(null);
  const [gallery, setGallery] = useState(null);
  const submitVolunteer = async (values) => {
    if (featuredImage || gallery) {
      const images = await upload(featuredImage, gallery);
      if (images) {
        if (images.featured_image) {
          values.featured_image = images.featured_image;
        }
        if (images.gallery_images) {
          values.gallery = images.gallery_images;
        }
      }
    }
    await editVolunteer(volunteer.id, values);
    history.push(`/volunteers/${volunteer.id}/view`);
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Edit Volunteer"
          mainLinkTitle="Volunteers"
          mainLinkUrl="/volunteers"
          activeLink="Edit"
        />
      </div>
      <div className="container-fluid">
        <div className="col-lg-12">
          <div className="card">
            {!loading ? (
              volunteer && (
                <div>
                  <div className="card-header">
                    <div>
                      <h4 className="card-title">
                        {volunteer[Object.keys(inputFields)[0]]} -{" "}
                        <span>Edit</span>{" "}
                      </h4>
                      <p className="card-title-desc">
                        <Link to="/volunteers" className="btn btn-soft-light">
                          <i className="fa fa-angle-left"></i> Volunteers
                        </Link>
                        <Link
                          to={`/volunteers/${volunteer.id}/view`}
                          className="btn btn-soft-light"
                        >
                          <i className="fa fa-eye"></i>
                        </Link>
                      </p>
                    </div>
                  </div>
                  <AddForm
                    data={volunteer}
                    edit={true}
                    featuredImage={featuredImage}
                    gallery={gallery}
                    setFeaturedImage={setFeaturedImage}
                    setGallery={setGallery}
                    submitForm={submitVolunteer}
                    inputFields={inputFields}
                    initialValues={initialValues}
                  />
                </div>
              )
            ) : (
              <div className="text-center">
                <Spinner />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  alert: state.alert,
  volunteer: state.volunteer,
});

const mapDispatchToProps = { editVolunteer, getVolunteer };

export default connect(mapStateToProps, mapDispatchToProps)(EditVolunteer);
